import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as models from '../../../utils/models';
import * as utils from '../../../utils/utilities';

class MTPhotographicRecordForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		generalView: Joi.array().min(1).required().label('View of Weld Joints'),
		weldJointsLineView: Joi.array()
			.min(1)
			.required()
			.label('Weld Joints of Line after Surface Preparation'),
		weldJointsContrastView: Joi.array()
			.min(1)
			.required()
			.label('View of Weld Joints after White Contrast Application.'),
		weldJointsMPIView: Joi.array()
			.min(1)
			.required()
			.label('View of Weld Joints during MPI'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.mapToArrayFromObject());

		this.setState({ data: initialData });
	};

	mapToArrayFromObject = (): models.PDFImageProps[] => {
		const images: models.PDFImageProps[] = [];

		const { data } = this.state;
		for (const key in data) images.push(...(data as any)[key]);

		return images;
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				<div className="row">
					<div className="col">
						{this.renderFileInput({
							max: 1,
							multiple: false,
							name: 'generalView',
							accept: 'image/*,application/pdf',
							label: 'General View',
							sublabel: 'View of Weld Joints',
							types: utils.getFileUploadTypes(),
						})}
					</div>
					<div className="col">
						{this.renderFileInput({
							max: 1,
							multiple: false,
							name: 'weldJointsLineView',
							accept: 'image/*,application/pdf',
							label: 'Line Surface Preparation',
							sublabel: 'Weld Joints of Line after Surface Preparation',
							types: utils.getFileUploadTypes(),
						})}
					</div>
				</div>

				<div className="row">
					<div className="my-4 divider"></div>
					<div className="col">
						{this.renderFileInput({
							max: 1,
							multiple: false,
							name: 'weldJointsContrastView',
							accept: 'image/*,application/pdf',
							label: 'White Contrast Application',
							sublabel: 'View of Weld Joints after White Contrast Application',
							types: utils.getFileUploadTypes(),
						})}
					</div>
					<div className="col">
						{this.renderFileInput({
							max: 1,
							multiple: false,
							name: 'weldJointsMPIView',
							accept: 'image/*,application/pdf',
							label: 'MPI',
							sublabel: 'View of Weld Joints during MPI.',
							types: utils.getFileUploadTypes(),
						})}
					</div>
				</div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

const initialData = {
	generalView: [],
	weldJointsLineView: [],
	weldJointsContrastView: [],
	weldJointsMPIView: [],
};

export default MTPhotographicRecordForm;
